import { api } from "./dataService";

export const fetchClaimFormSectionTemplateAffectedForms = async (template_id) => {
  return (await api.get(`data/claim-form-section-templates/${template_id}/affected-forms`)).data;
};

export const propagateClaimFormSectionTemplate = async (template_id, form_ids) => {
  return (
    await api.post(`data/claim-form-section-templates/${template_id}/propagate`, {
      ...(form_ids ? { form_ids } : {}),
    })
  ).data;
};
